export default "__VITE_ASSET__70e11b4f__"